<template>
    <BaseCollapseItem
        :title="$t('widget.layout')"
        name="layout"
        class="simple-collapse"
    >
        <div>
            <RedesignFormItem>
                <RedesignCheckbox v-model="widgetLayoutModel.hideContainer">
                    {{ $t('widget.hideContainer') }}
                </RedesignCheckbox>
            </RedesignFormItem>
            <RedesignFormItem
                :label="$t('widget.config.cardTitleFontSize')"
            >
                <RedesignInputNumber
                    v-model="widgetLayoutModel.titleFontSize"
                    :max="titleCardFontSizes.max"
                    :min="titleCardFontSizes.min"
                    :step="1"
                    placeholder="0"
                />
            </RedesignFormItem>
            <RedesignFormItem
                :label="$t('widget.config.cardValueFontSize')"
            >
                <RedesignInputNumber
                    v-model="widgetLayoutModel.valueFontSize"
                    :max="valueCardFontSizes.max"
                    :min="valueCardFontSizes.min"
                    :step="1"
                    placeholder="0"
                />
            </RedesignFormItem>
            <RedesignFormItem
                :label="$t('widget.config.valueIconMinWidth')"
            >
                <RedesignInputNumber
                    v-model="widgetLayoutModel.valueIconMinWidth"
                    :max="valueCardMinWidth.max"
                    :min="valueCardMinWidth.min"
                    :step="1"
                    placeholder="0"
                />
            </RedesignFormItem>
            <div>
                <RedesignWidgetColors
                    v-model="widgetLayoutModel.colors"
                    :available-colors="availableColors"
                />
            </div>
        </div>
    </BaseCollapseItem>
</template>

<script setup lang="ts">
import {
    titleCardFontSizes,
    valueCardFontSizes,
    valueCardMinWidth
} from '@/components/RedesignComponents/Widgets/widgets.enum'
import RedesignFormItem from '@/components/RedesignBaseComponents/Form/RedesignFormItem.vue'
import RedesignWidgetColors from '@/components/RedesignComponents/Widgets/Common/RedesignWidgetColors.vue'
import RedesignInputNumber from '@/components/RedesignBaseComponents/Inputs/RedesignInputNumber.vue'
import RedesignCheckbox from '@/components/RedesignBaseComponents/Inputs/RedesignCheckbox.vue'
import BaseCollapseItem from '@/components/RedesignBaseComponents/Collapse/BaseCollapseItem.vue'
import { WidgetLayout } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'
import { computed } from 'vue'
import { getAllDefaultCardColors } from '@/enum/defaultWidgetSettings'

const props = defineProps<{
    value: WidgetLayout
}>()
const emit = defineEmits([ 'input' ])

const widgetLayoutModel = useVModel(props, 'value', emit, {
    eventName: 'input'
})

const availableColors = computed(() => {
    return getAllDefaultCardColors()
})
</script>

